/* istanbul ignore file */
import React from 'react';
import { useEmployeeUrl } from 'domain/shared/employee';
import { LinkButton, LinkButtonProps } from 'framework/ui/ui-builder';

const ViewEmployeeButton = (props: Omit<LinkButtonProps, 'children' | 'url'>) => {
  const { getSingleEntityUrl } = useEmployeeUrl();

  return (
    <LinkButton {...props} url={getSingleEntityUrl} key="view-employee" variant="outlined">
      View
    </LinkButton>
  );
};

export default ViewEmployeeButton;
